<template>
  <div>
    <h6>{{ $t("datasubject-right.text") }}</h6>

    <LibraryItems
      rightPanelId="sidebar-new-datasubject-datasubject-right"
      organizationScopedState="datasubjectDatasubjectRight"
      libraryScopedState="datasubjectRight"
      :hideCategoryFilter="true"
      :hideSaveAs="true"
      @interceptForSetParent="interceptForSetParent"
    />
  </div>
</template>

<script>
import LibraryItems from "@cc/library-items";

export default {
  components: {
    LibraryItems,
  },

  computed: {
    isUpdating() {
      return this.$store.getters["datasubjectDatasubjectRight/isUpdating"];
    },
    //

    editedDatasubject() {
      return this.$store.getters["datasubjectDatasubjectRight/editedDatasubject"];
    },
  },
  methods: {
    cancel() {
      this.$store.dispatch("datasubjectDatasubjectRight/resetForm");
    },

    interceptForSetParent(payload) {
      payload.datasubject = this.editedDatasubject;
    },
  },
};
</script>
